import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div className="page">
    <div className="container" style={{ textAlign: 'center', padding: '80px 20px' }}>
      <div style={{
        fontFamily: 'var(--font-display)',
        fontSize: 120,
        fontWeight: 800,
        background: 'linear-gradient(135deg, var(--primary-600), var(--accent-500))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        lineHeight: 1,
      }}>
        404
      </div>
      <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, marginBottom: 12 }}>
        Page not found
      </h1>
      <p style={{ color: 'var(--gray-500)', marginBottom: 32, maxWidth: 480, margin: '0 auto 32px' }}>
        The page you're looking for doesn't exist or has been moved.
        Let's get you back on track.
      </p>
      <Link to="/" className="btn btn-primary btn-lg">Back to home</Link>
    </div>
  </div>
);

export default NotFound;
